import { store } from '../../../../../stateManager';
import { copyObj, getValue, getComponents } from './';

export const getGridSpanStyles = (id: string) => {
  const state = store.getState()
  const { components } = getComponents()
  let styles = copyObj(state.formJson.gridStyles)

  if(id) {
    const component = copyObj(components[id])
    styles = component.properties.styles
  }

  const spanStyles: any = {
    properties: {
      styles: {}
    }
  }

  const deviceTypes = ['Lg', 'Md', 'Sm']
  deviceTypes.forEach((deviceType: string) => {
    spanStyles.properties.styles[deviceType] = {
      span: getValue(styles, `${deviceType}.gridCols`.split("."), "")
    }
  })

  return spanStyles
}
